import React from 'react'
import CheckBox from '../ui/CheckBox.jsx';


const SelectTherapyArea = (props) => {
  let {area} = props;
  return <li key={area._id}>
          <CheckBox
            label={area.name}
            onClick={(e) => {
              e.stopPropagation();
              return props.click(area)}
            }
            on={props.checkedCond(area)}/>
        </li>

}

export default SelectTherapyArea;



// WEBPACK FOOTER //
// ./src/components/admin/SelectTherapyArea.jsx